import {
  EMOJI_TYPE,
  TIPTAP_COLLAPSIBLE_ITEM_BODY_TYPE,
  TIPTAP_COLLAPSIBLE_ITEM_TITLE_TYPE,
  TIPTAP_COLLAPSIBLE_ITEM_TYPE,
} from 'ricos-content';
import { Node_Type } from 'ricos-types';

import { DEFAULTS } from '../defaults';

export const defaultCollapsibleItem = [
  {
    type: TIPTAP_COLLAPSIBLE_ITEM_TYPE,
    content: [
      {
        type: TIPTAP_COLLAPSIBLE_ITEM_TITLE_TYPE,
        content: [
          {
            type: Node_Type.PARAGRAPH,
            content: [],
          },
        ],
      },
      {
        type: TIPTAP_COLLAPSIBLE_ITEM_BODY_TYPE,
        content: [
          {
            type: Node_Type.PARAGRAPH,
            content: [],
          },
        ],
      },
    ],
  },
];

export const defaultCollapsibleList = {
  content: defaultCollapsibleItem,
  containerData: { alignment: 'CENTER', textWrap: true },
  ...DEFAULTS.config,
};

export const supportedPluginTypes = [
  `${Node_Type.AUDIO}.audio`,
  `${Node_Type.AUDIO}.soundCloud`,
  `${Node_Type.AUDIO}.spotify`,
  Node_Type.FILE,
  Node_Type.IMAGE,
  Node_Type.GALLERY,
  `${Node_Type.VIDEO}.video`,
  `${Node_Type.VIDEO}.youTube`,
  Node_Type.GIF,
  Node_Type.DIVIDER,
  EMOJI_TYPE,
  Node_Type.CODE_BLOCK,
  `${Node_Type.APP_EMBED}.event`,
  `${Node_Type.APP_EMBED}.booking`,
  `${Node_Type.APP_EMBED}.product`,
  `${Node_Type.LINK_PREVIEW}.instagram`,
  `${Node_Type.LINK_PREVIEW}.twitter`,
  `${Node_Type.LINK_PREVIEW}.pinterest`,
  `${Node_Type.LINK_PREVIEW}.facebook`,
  `${Node_Type.LINK_PREVIEW}.tiktok`,
];
